import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as lightbox from '@elements/lightbox';
lightbox.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as datepicker from '@elements/datepicker';
datepicker.init();

import * as smoothScroll from '@elements/smooth-scroll';
smoothScroll.init({scrollOffset: 160});

import * as affix from "@elements/affix";
if (matchMedia('(min-width: 768px)').matches) {
    affix.init({}, {
        base:'.js-affix',
        placeholder:'.js-affix__placeholder',
        container: '.js-affix__container'
    });
}

import Collapse from 'bootstrap/js/dist/collapse';
onFind('[data-bs-toggle="collapse"]',function (element) {
    new Collapse(element);
});

import Tab from 'bootstrap/js/dist/tab';
onFind('[data-bs-toggle="tab"]',function (element) {
    new Tab(element);
});

import * as dynamicTabbing from './scripts/dynamic-tabbing';
dynamicTabbing.init();

import * as tabbingAnimations from './scripts/tabbing-animations';
tabbingAnimations.init();

import * as mobileCollapse from './scripts/mobile-collapse';
mobileCollapse.init();

import * as hotspotPopup from './scripts/hotspot-popup';
hotspotPopup.init();

import * as googleMap from './scripts/google-map-hotspots'
googleMap.init()